module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "smart-image"
  }, [_c('img', {
    staticClass: "load",
    attrs: {
      "src": "/static/img/loading.gif",
      "alt": "",
      "height": "30"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44fcc934","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/SmartImage.vue
// module id = 879
// module chunks = 0